"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _times = require("HubStyleTokens/times");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIDragHandle = _interopRequireDefault(require("../draggable/UIDragHandle"));

var _H = _interopRequireDefault(require("../elements/headings/H7"));

var _IconConstants = require("../icon/IconConstants");

var _UICaret = _interopRequireDefault(require("../icon/icons/UICaret"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _decorators = require("../utils/propTypes/decorators");

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _ExpandableConstants = require("./ExpandableConstants");

var _UIExpandableContents = _interopRequireDefault(require("./UIExpandableContents"));

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  left: 8px;\n  opacity: ", ";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: opacity ", " ease-out;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transition: all ", " ease-in-out;\n  transform: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  width: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  padding: 10px 0;\n  transition: color ", " ease-out;\n  user-select: none;\n\n  &:hover:not([aria-disabled='true']) {\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-color: ", ";\n  border-style: solid;\n  border-width: 1px 0 0 0;\n  display: flex;\n  justify-content: space-between;\n  padding-left: 0;\n  padding-right: ", ";\n  position: relative;\n  ", ";\n\n  /* Shim open w/ generated content to get min-height effect in IE11 */\n  &::after {\n    content: '';\n    height: 54px;\n    margin-left: -1px;\n    width: 1px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  margin-left: ", ";\n\n  *:first-child > * + * {\n    margin-left: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border-width: 1px 0;\n  margin-bottom: -1px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var USE_OPTIONS = ['default', 'enclosed'];
var getEnclosedStyle = (0, _styledComponents.css)(_templateObject(), _ExpandableConstants.EXPANDABLE_DARK_BACKGROUND);

var ExpandableActions = _styledComponents.default.div.withConfig({
  displayName: "UIExpandableSection__ExpandableActions",
  componentId: "ihp28s-0"
})(_templateObject2(), _ExpandableConstants.EXPANDABLE_ACTIONS_SPACING_X, _ExpandableConstants.EXPANDABLE_ACTIONS_SPACING_X);

var ExpandableWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIExpandableSection__ExpandableWrapper",
  componentId: "ihp28s-1"
})(_templateObject3());

var ExpandableHeader = _styledComponents.default.div.withConfig({
  displayName: "UIExpandableSection__ExpandableHeader",
  componentId: "ihp28s-2"
})(_templateObject4(), _ExpandableConstants.EXPANDABLE_DARK_BORDER_COLOR, _ExpandableConstants.EXPANDABLE_PADDING_X, function (props) {
  return props.use === 'enclosed' ? getEnclosedStyle : null;
});

ExpandableHeader.propTypes = {
  use: _propTypes.default.oneOf(USE_OPTIONS)
};
var ExpandableButton = (0, _styledComponents.default)(_UIClickable.default).withConfig({
  displayName: "UIExpandableSection__ExpandableButton",
  componentId: "ihp28s-3"
})(_templateObject5(), function (props) {
  return props.disabled ? _ExpandableConstants.EXPANDABLE_OPENER_DISABLED_COLOR : undefined;
}, _times.MICRO_TRANSITION_TIMING, _ExpandableConstants.EXPANDABLE_OPENER_HOVER_COLOR);
var ExpandableTitle = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
      titleText = _ref.titleText;
  return (
    /*
     * Here, we need to null out the `aria-level` otherwise it defaults to `2`,
     * so we disable the lint rule to allow it to be a non-integer. Then we need
     * to disable the rule to allow `aria-level` to be there with `presentation`
     * since the <H7> component has a default of `role="heading"`.
     * */

    /* eslint-disable jsx-a11y/role-supports-aria-props */

    /* eslint-disable jsx-a11y/aria-proptypes */
    _react.default.createElement(_H.default, {
      "aria-level": null,
      className: className,
      role: "presentation"
    }, titleText)
    /* eslint-enable jsx-a11y/aria-proptypes */

    /* eslint-enable jsx-a11y/role-supports-aria-props */

  );
}).withConfig({
  displayName: "UIExpandableSection__ExpandableTitle",
  componentId: "ihp28s-4"
})(_templateObject6());
ExpandableTitle.propTypes = {
  titleText: _propTypes.default.node
};

var ExpandableCaretHolder = _styledComponents.default.span.withConfig({
  displayName: "UIExpandableSection__ExpandableCaretHolder",
  componentId: "ihp28s-5"
})(_templateObject7(), _ExpandableConstants.EXPANDABLE_PADDING_LEFT);

var ExpandableCaret = (0, _styledComponents.default)(_UICaret.default).attrs({
  color: _ExpandableConstants.EXPANDABLE_OPENER_COLOR,
  viewBoxHeight: _IconConstants.CARET_HEIGHT,
  viewBoxWidth: _IconConstants.CARET_WIDTH,
  height: 12,
  width: 5
}).withConfig({
  displayName: "UIExpandableSection__ExpandableCaret",
  componentId: "ihp28s-6"
})(_templateObject8(), _times.MICRO_TRANSITION_TIMING, function (props) {
  return props.open ? 'rotate(90deg)' : null;
});

var ExpandableDragHandleHolder = _styledComponents.default.span.withConfig({
  displayName: "UIExpandableSection__ExpandableDragHandleHolder",
  componentId: "ihp28s-7"
})(_templateObject9(), function (props) {
  return props.hovered ? '1' : '0';
}, _times.MICRO_TRANSITION_TIMING);

var DefaultContentWrapper = function DefaultContentWrapper(props) {
  var open = props.open,
      children = props.children,
      className = props.className,
      indentation = props.indentation,
      use = props.use;
  return _react.default.createElement(_UIExpandableContents.default, {
    "aria-hidden": open ? 'false' : 'true',
    className: className,
    indentation: indentation,
    use: use
  }, children);
};

DefaultContentWrapper.propTypes = {
  open: _propTypes.default.bool,
  children: _propTypes.default.node,
  indentation: _UIExpandableContents.default.propTypes.indentation,
  use: _propTypes.default.oneOf(USE_OPTIONS)
};

var DefaultCaret = function DefaultCaret(props) {
  var open = props.open;
  return _react.default.createElement(ExpandableCaret, {
    open: open
  });
};

var UIExpandableSection = function UIExpandableSection(props) {
  var actions = props.actions,
      Caret = props.Caret,
      children = props.children,
      contentClassName = props.contentClassName,
      ContentWrapper = props.ContentWrapper,
      disabled = props.disabled,
      DragHandle = props.DragHandle,
      draggable = props.draggable,
      Header = props.Header,
      __hovered = props.hovered,
      indentation = props.indentation,
      onOpenChange = props.onOpenChange,
      open = props.open,
      Opener = props.Opener,
      titleText = props.titleText,
      Title = props.Title,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["actions", "Caret", "children", "contentClassName", "ContentWrapper", "disabled", "DragHandle", "draggable", "Header", "hovered", "indentation", "onOpenChange", "open", "Opener", "titleText", "Title", "use"]);
  return _react.default.createElement(_HoverProvider.default, props, function (hoverProviderProps) {
    var hovered = hoverProviderProps.hovered,
        hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
    return _react.default.createElement(ExpandableWrapper, (0, _extends2.default)({}, rest, hoverProviderRestProps), _react.default.createElement(Header, {
      use: use
    }, draggable ? _react.default.createElement(ExpandableDragHandleHolder, {
      hovered: hovered
    }, _react.default.createElement(DragHandle, null)) : null, titleText ? _react.default.createElement(Opener, {
      "aria-expanded": open ? 'true' : 'false',
      disabled: disabled,
      onClick: function onClick() {
        onOpenChange((0, _SyntheticEvent.default)(!open));
      }
    }, _react.default.createElement(ExpandableCaretHolder, null, _react.default.createElement(Caret, {
      open: open
    })), _react.default.createElement(Title, {
      titleText: titleText
    })) : null, actions ? _react.default.createElement(ExpandableActions, null, actions) : null), children ? _react.default.createElement(_AccordionTransition.default, {
      open: open
    }, _react.default.createElement(ContentWrapper, {
      open: open,
      className: contentClassName,
      indentation: indentation,
      use: use
    }, children)) : null);
  });
};

UIExpandableSection.propTypes = {
  actions: _propTypes.default.node,
  children: _propTypes.default.node,
  Caret: _propTypes.default.elementType,
  contentClassName: _propTypes.default.string,
  ContentWrapper: RenderProp.getPropType(DefaultContentWrapper).isRequired,
  disabled: _propTypes.default.bool.isRequired,
  draggable: _propTypes.default.bool.isRequired,
  DragHandle: _propTypes.default.elementType,
  Header: RenderProp.getPropType(ExpandableHeader).isRequired,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  indentation: _UIExpandableContents.default.propTypes.indentation,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  Opener: _propTypes.default.elementType,
  titleText: ExpandableTitle.propTypes.titleText,
  Title: RenderProp.getPropType(ExpandableTitle).isRequired,
  use: _propTypes.default.oneOf(USE_OPTIONS)
};
UIExpandableSection.defaultProps = {
  Caret: DefaultCaret,
  ContentWrapper: DefaultContentWrapper,
  disabled: false,
  draggable: false,
  DragHandle: _UIDragHandle.default,
  Header: ExpandableHeader,
  indentation: _UIExpandableContents.default.defaultProps.indentation,
  open: false,
  Opener: ExpandableButton,
  Title: ExpandableTitle,
  use: 'default'
};
UIExpandableSection.displayName = 'UIExpandableSection';

var _default = (0, _Controllable.default)(UIExpandableSection, ['open']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/accordion/UIExpandableSection.js
// module id = 597
// module chunks = 5 6